import React, {useMemo} from "react";
import {NavLink, useLocation} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronRight} from "@fortawesome/pro-regular-svg-icons/faChevronRight";

import {toggleSidebarMenu} from "@/helpers/toggleSidebarMenu.js";
import Button from "@/components/Global/Button/Button";

import styles from "./SidebarDropdown.module.scss";

export default function SidebarDropdown({route}) {
  const {subRoutes = []} = route;
  const {pathname} = useLocation();

  const isActive = useMemo(() => {
    return subRoutes.some(({path}) => pathname.includes(path));
  }, [pathname, route?.path]);

  const routeId = route?.path?.replace("/", "");
  const isExpanded = useMemo(
    () => pathname.includes(route?.path) || subRoutes.some(({path}) => pathname.includes(path)),
    [pathname],
  );

  const handleClick = path => {
    if (!path) return;

    if (path === pathname) {
      toggleSidebarMenu({isOpen: false});
    }
  };

  return (
    <>
      <Button
        variant="transparent"
        className={`w-100 ${styles.navItem} justify-content-between`}
        data-bs-toggle="collapse"
        data-bs-target={`#${routeId}`}
        aria-expanded={isExpanded}>
        <div className={styles.dropdownBtn}>
          <FontAwesomeIcon icon={route.icon} />
          {route.title}
        </div>
        <FontAwesomeIcon icon={faChevronRight} className={`fa-fw ${styles.dropdownArrow}`} size="sm" />
      </Button>
      <div className={`collapse ${isExpanded ? "show" : ""}`} id={`${routeId}`}>
        <ul id="childrenItems" className="btn-toggle-nav list-unstyled">
          {subRoutes
            .filter(subRoute => subRoute.show)
            .map(subRoute => {
              const isActive = pathname.includes(subRoute?.path);
              let path = ["/tcs-and-privacy"].includes(route.path)
                ? `${subRoute.path}`
                : `/my-account/${route.path}/${subRoute.path}`;

              const isExternalLink = path.includes("http");

              if (isExternalLink) {
                const url = new URL(path);
                if (config.isNativeApp) {
                  url.searchParams.set("external", "true");
                }
                path = url.toString();

                return (
                  <li key={subRoute.path} onClick={() => handleClick(path)}>
                    <a href={path} target="_blank" className={`${styles.subItem} ${isActive ? styles.active : ""}`}>
                      {subRoute.title}
                    </a>
                  </li>
                );
              }

              return (
                <li key={subRoute.path} onClick={() => handleClick(path)}>
                  <NavLink to={path} className={`${styles.subItem} ${isActive ? styles.active : ""}`}>
                    {subRoute.title}
                  </NavLink>
                </li>
              );
            })}
        </ul>
      </div>
    </>
  );
}
